import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { PageHeader } from '@lmc/ui-kit'
import styled from 'styled-components'
import dayjs from 'dayjs'
import { NAMESPACE } from 'locale'
import { incidentReportsConstants } from 'locale/incidentReports'
import ActionsTable from './ActionsTable'
import ActionsFilters, { IncidentActionsFilterValues } from './ActionsFilters'
import { useIncidentActions } from './hooks/useIncidentActions'
import useFilterParamsGeneric from 'hooks/useFilterParamsGeneric'

const CURRENT_PAGE = 1
const ITEMS_PER_PAGE = 10

const IncidentsActions: React.FC = () => {
  const { t } = useTranslation(NAMESPACE.INCIDENT_REPORTS)

  const [currentPage, setCurrentPage] = useState(CURRENT_PAGE)
  const [itemsPerPage, setItemsPerPage] = useState(ITEMS_PER_PAGE)



  const initialFiltersValue: IncidentActionsFilterValues = {
	rangePicker: [dayjs().subtract(4, 'week').startOf('day'), dayjs()],
	residents: [],
	categoryItems: [],
	statuses: [],
	ownedBy: [],
  }

  const { filterParamsGeneric: filterParams, setFilterParams } =
  useFilterParamsGeneric(initialFiltersValue)

  const { data, isLoading } = useIncidentActions({
    filterParams: {
      ...filterParams,
      currentPage,
      itemsPerPage,
    },
    enabled: true,
  })

  const onFilterChange = (value: Partial<IncidentActionsFilterValues>) => {
    setFilterParams((prev) => ({
      ...prev,
      ...value,
    }))
    setCurrentPage(CURRENT_PAGE)
  }

  const handlePageChange = (page: number, size?: number) => {
    setCurrentPage(page)
    if (size && size !== itemsPerPage) {
      setItemsPerPage(size)
      setCurrentPage(CURRENT_PAGE)
    }
  }

  return (
    <ContentContainer data-testid="incidents-actions-container">
      <PageHeader
        data-testid="page-header"
        title={
          <TitleContainer>
            {t(incidentReportsConstants.INCIDENT_ACTIONS)}
          </TitleContainer>
        }
      />
      <ActionsFilters
        data-testid="actions-filters"
        filterParams={filterParams}
        onFilterChange={onFilterChange}
      />
      <ActionsTable
        data-testid="actions-table"
        actionsData={data}
        isLoading={isLoading}
        currentPage={currentPage}
        itemsPerPage={itemsPerPage}
        onPageChange={handlePageChange}
      />
    </ContentContainer>
  )
}

const ContentContainer = styled.div`
  max-width: 1480px;
  padding: 24px 0 50px;
  margin: 0 24px;
  display: flex;
  flex-direction: column;
  gap: 24px;
`

const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`

export default IncidentsActions
